import React, { useEffect, useState } from 'react';
import MetadataList from './components/MetadataList';
import MetadataDetail from './components/MetadataDetail';
import About from './components/About';
import { useTranslation } from 'react-i18next';
import { MetadataProvider } from './MetadataContext';
import { TagOutlined } from '@ant-design/icons';

export default function Metadata() {
    const { t } = useTranslation(['metadata']);
    const [metadataList, setMetadataList] = useState();
    // get metadata list
    const getMetadataList = async () => {
        const list = [];
        mockData?.forEach((val) => {
            const subList = [];
            val?.subTitle?.forEach((item) => {
                subList.push({
                    title: (
                        <span className="custom-title">
                            <div className="line-clamp-3">{item?.title}</div>
                        </span>
                    ),
                    titleName: item?.title,
                    key: item?.key,
                    isLeaf: true,
                    icon: <TagOutlined />,
                });
            });
            list?.push({
                title: val.title,
                titleName: val?.title,
                key: val?.id,
                children: subList,
            });
        });
        setMetadataList(list);
    };

    useEffect(() => {
        getMetadataList();
    }, []);

    return (
        <MetadataProvider>
            <div className="title ">{t('Metadata')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Catalog')} /{' '}
                </span>
                <span> {t('Metadata')}</span>
            </div>
            <div className="grid grid-cols-7 gap-4 mt-4">
                <div className="w-full col-span-2">
                    <MetadataList metadataList={metadataList} />
                </div>
                <div className="w-full col-span-5 flex flex-col space-y-4">
                    <About />
                    <MetadataDetail />
                </div>
            </div>
        </MetadataProvider>
    );
}

const mockData = [
    {
        title: 'Personal Data',
        id: 'm001',
        subTitle: [
            {
                title: 'Barcode พ.ร.บ.',
                key: 's1001',
            },
            {
                title: 'การศึกษา',
                key: 's1002',
            },
            {
                title: 'ชื่อ, ชื่อกลาง, นามสกุล, นามแฝง ของผู้เอาประกันภัย ผู้ถือกรมธรรม์ประกันภัย และผู้รับประโยชน์',
                key: 's1003',
            },
            {
                title: 'ทะเบียนรถยนต์ / หมายเลขตัวถัง / รุ่นรถยนต์',
                key: 's1004',
            },
            {
                title: 'ที่อยู่',
                key: 's1005',
            },
        ],
    },
    {
        title: 'Sensitive Data',
        id: 'm002',
        subTitle: [
            {
                title: 'ศาสนา',
                key: 's2001',
            },
            {
                title: 'กรุ๊ปเลือด',
                key: 's2002',
            },
            {
                title: 'ข้อมูลชีวภาพ (biometric data) (เช่น การจดจำใบหน้า (face recognition) ลายนิ้วมือ (fingerprint) การจดจำเสียง (voice recognition) และการจดจำม่านตา (retina recognition))',
                key: 's2003',
            },
        ],
    },
];
